export default "__VITE_ASSET__B0tbEAY9__"